module.exports = "https://static.wmbcdn.com/uniweb/images/eff4429c41f713ec2dee436bc11dd2ce.svg";